import React, { useState } from 'react'
import * as Yup from 'yup';
import { Modal, Row } from 'antd'
import { Button, FormSubmitButton, FormTextArea, MasterDetailForm, Widget } from '@digital/ui'
import { UploadMultipleTable, Visibility } from '@app/components';
import { ordemCompraIdState } from '../atoms'
import { useRecoilValue } from 'recoil';
import { reprovarRelatorioHomologacao } from '@app/api/sas/relatorioHomologacao';
import { vtObjToFormData } from '@app/helpers/objHelper';

const ModalReprovarRelatorioHomologacao = ({ onReloadRelatorio }: any) => {
    const [exibirModal, setExibirModal] = useState(false)
    const ordemCompraId = useRecoilValue(ordemCompraIdState)

    const onCancel = () => {
        setExibirModal(false)
    }

    const onSubmit = async (values: any) => {
        const form = vtObjToFormData(values)
        form.append('ordemCompraId', ordemCompraId)
        const result = await reprovarRelatorioHomologacao(form)
        if (result && result.valid) {
            setExibirModal(false)
            onReloadRelatorio()
        }
    }

    return (
        <>
            <Button title='Solicitar Revisão' style={{ marginRight: '10px' }} onClick={() => setExibirModal(true)} type='primary' />
            <Visibility visible={exibirModal} >
                <Modal
                    title='Solicitação de aprovação do Gerente'
                    width='780px'
                    visible={exibirModal}
                    onCancel={onCancel}
                    footer={null}
                >
                    <MasterDetailForm
                        key="form-reprovar-relatorio-homologacao"
                        onSubmit={onSubmit}
                        validationSchema={Yup.object().shape({
                            justificativa: Yup.string().required('Campo obrigatário')
                        })}
                        actions={[
                            <Button title='Fechar' onClick={onCancel} type='link' />,
                            <FormSubmitButton noIcon type='primary' title='Enviar' />
                        ]}
                    >
                        <Widget>
                            <Row>
                                <FormTextArea name="justificativa" label='Justificativa' span={12} rows={3} />
                            </Row>
                            <Row>
                                <UploadMultipleTable idDoComponente='upload-reprovar-relatorio-homologacao' name='arquivos' type='primary' />
                            </Row>
                        </Widget>
                    </MasterDetailForm>
                </Modal>
            </Visibility>
        </>
    )
}

export default ModalReprovarRelatorioHomologacao